<template>
  <div class="form-area">
    <div class="form-row">
      <div class="input-wrap">
        <validation-provider rules="required"
            name="対象日"
            vid="emergency_search_date"
            v-slot="v">
          <my-calendar
            v-model="emergencySearch.date"
            :input-class-obj="v.classes">
          </my-calendar>
        </validation-provider>
      </div>

      <div class="input-wrap">
        <validation-provider rules="required"
          vid="emergency_search_car_id"
          v-slot="v">
            <select class="custom-select max-w350" v-model="emergencySearch.deviceId" :class="v.classes">
              <option v-for="e in cars" :key="e.id" :value="e.device_id">
                {{e.car_name}}
              </option>
            </select>
        </validation-provider>
      </div>
      <div class="btn-wrap">
        <button class="btn btn-lg btn-primary"
            @click="doEmergencySearch()"
            :disabled="isRequesting">
          <i class="fa fa-spinner fa-spin"
            v-show="isRequesting"></i>
          検索
        </button>
      </div>
    </div>
    <div class="form-row list-video-area">
      <div class="list-area">
        <template v-if="!isRequesting && isSearchButtonClicked">
          <div class="tbl" v-if="hasList">
            <div class="tbl-row row-type1 bg-light">
              <div class="cell col-left">日時</div>
              <div class="cell col-left">車両番号</div>
              <div class="cell col-left">種別</div>
              <div class="cell col-left">カメラ</div>
              <div class="cell col-left">場所/地名</div>
            </div>
            <div class="tbl-rows">
              <div class="tbl-row row-type2" v-for="e in emergencyList" :key="e.id"
                @click="selectMovie(e.id)"
                :class="{ selected: e.id === selectedMovieId }">
                <div class="cell col-left">{{e.ts}}</div>
                <div class="cell">{{e.device_name}}</div>
                <div class="cell">{{e.movie_type_disp}}</div>
                <div class="cell">{{e.camera_name}}</div>
                <div class="cell col-left">{{e.landmark_disp || e.local_address}}</div>
              </div>
            </div>
          </div>
          <div class="not-found-msg text-warning" v-else>
            緊急通報が見つかりませんでした。
          </div>
        </template>
      </div>
      <div class="video-area" v-show="selectedMovieId">
        <video class="video-player" crossorigin="anonymous" controls ref="videoElement">
        </video>
        <div class="btn-wrap">
          <button class="btn btn-lg btn-primary"
              @click="takeScreenshot">
            切り出し
          </button>
        </div>
      </div>
      <div class="text-warning ml-2" v-if="hasList && !selectedMovieId">
        一覧から動画を選択してください
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import landApDataApi from 'src/apis/land_ap_data'

export default {
  name: 'emergency-selector',
  data() {
    return {
      emergencySearch: {
        date: new Date(),
        deviceId: null,
      },
      cars: [],
      hasList: false,
      emergencyList: [],
      isSearchButtonClicked: false,
      isRequesting: false,
      selectedMovieId: null,
    }
  },
  async mounted() {
    const { data } = await landApDataApi.getDevices()
    this.cars = data
    this.emergencySearch.deviceId = data[0].device_id
  },
  methods: {
    selectMovie(id) {
      const token = this.$store.getters['localStorage/serverToken']
      if (!token) {
        return
      }
      this.selectedMovieId = id
      const videoEl = this.$refs.videoElement
      videoEl.src = `/api/v1/land_ap/movies/${id}/file?token=${token}`
      videoEl.load()
    },
    async doEmergencySearch() {
      if (!this.emergencySearch.date || !this.emergencySearch.deviceId) {
        return
      }
      this.isSearchButtonClicked = true
      this.isRequesting = true
      this.selectedMovieId = null
      const params = {
        dt_from: this.emergencySearch.date,
        dt_to: this.emergencySearch.date,
        device_id: this.emergencySearch.deviceId,
      }
      try {
        const { data } = await landApDataApi.getMovices(params)
        this.emergencyList = data
        this.hasList = data.length > 0
      } catch (err) {
        console.error(err)
      }

      this.isRequesting = false
    },
    parseJsonLandmark(jsonLandmark) {
      let landmark = null
      if (!jsonLandmark) { return landmark }

      try {
        landmark = JSON.parse(jsonLandmark)
      } catch (e) {
        landmark = null
      }

      return landmark
    },
    async takeScreenshot() {
      try {
        const videoEl = this.$refs.videoElement
        videoEl.pause()
        const blob = await this._getScreenshotBlob()
        const selectedMovie = this.emergencyList.find(e => e.id === this.selectedMovieId)
        const params = {
          filename: `emergency_${Vue.filter('dtFormat')(new Date(), 'yyyymmdd_HHMMSS')}.jpg`,
          type: 'image/jpeg',
          file: blob,
          src: window.URL.createObjectURL(blob),
          metadata: {
            datetime: new Date(selectedMovie.ts),
            latitude: selectedMovie.lat,
            longitude: selectedMovie.lon,
            geo_locations: '', // 緊急通報動画からは取れないので空でよい
            pole: this.parseJsonLandmark(selectedMovie.landmark), // 首都技の場合landmarkには常にポールが入っている
          },
        }
        this.$emit('selected-screenshot', params)
      } catch (err) {
        console.warn(err)
      }
    },
    async _getScreenshotBlob() {
      const videoEl = this.$refs.videoElement
      const canvas = document.createElement('canvas')
      canvas.width = videoEl?.videoWidth
      canvas.height = videoEl?.videoHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height)

      const mimeTypeJpeg = 'image/jpeg'
      const jpegQuality = 0.92
      if (canvas.toBlob) {
        return await new Promise(resolve => {
          return canvas.toBlob(blob => resolve(blob), mimeTypeJpeg, jpegQuality)
        })
      } else {
        // toDataURLで戻ってくるのはstringだが、中で呼び出してるFileSaverで
        // stringの場合はCORSのチェックをするためにsynchronousなXMLHttpRequest
        // を投げていて、少なくともchromeだとdeprecatedなwarningが出て気になる
        // のでなるべく使いたくない.
        const dataURL = canvas.toDataURL(mimeTypeJpeg, jpegQuality)
        return this._canvasDataURLToBlob(dataURL)
      }
    },
    _canvasDataURLToBlob(dataURL) {
      const tmpURIPart = dataURL.split(',')
      const meta = tmpURIPart[0]
      const data = tmpURIPart[1]
      const bs = meta.indexOf('base64') >= 0 ? atob(data) : decodeURI(data)
      const ia = new Uint8Array(bs.length)
      for (let i = 0, len = bs.length; i < len; i++) {
        ia[i] = bs.charCodeAt(i)
      }
      const mimeString = meta.split(':')[1].split(';')[0]
      return new Blob([ia], { type: mimeString })
    },
  },
}
</script>

<style lang="scss" scoped>
.list-video-area {
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: start;
}
.list-area {
  // カレンダー選択を表示できる高さ
  min-height: 250px;
  .tbl, .not-found-msg {
    margin: 0 0 20px;
  }
  .tbl {
    .tbl-rows {
      max-height: 250px;
      overflow-y: auto;
    }
    .tbl-row {
      display: grid;
      grid-template-columns: 108px 160px 60px 70px 1fr;
      justify-items: center;
      border-bottom: 1px solid #dfd7ca;
    }
    .cell {
      display: flex;
      align-items: center;
      padding: 6px 8px;
      word-break: break-all;
    }
    .row-type1 {
      border-top: 1px solid #dfd7ca;
    }
    .row-type2 {
      &:hover { background-color: #ebebeb; }
      &.selected {
        background-color: #f5efea;
        &:hover { background-color: #e1dbd6; }
      }
    }
    .col-left {
      justify-self: start;
    }
  }
}
.input-wrap, .btn-wrap {
  margin: 6px 12px 20px;
}
.video-area {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .video-player {
    padding: 0px 8px;
    top: 0;
    left: 0;
    right: 0;
    max-height: 300px;
  }
}
</style>
